
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32pt","height":"32pt","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21.5 3c-5.066 0-9.207 4-9.469 9H12v6.781l-8-7.156L3.281 11l-.656.688L1 13.312l.563.688L12 27.344V29h15v-8.781c2.414-1.723 4-4.535 4-7.719C31 7.266 26.734 3 21.5 3zm0 2c4.152 0 7.5 3.348 7.5 7.5a7.477 7.477 0 01-2 5.094V12H14.031c.254-3.922 3.48-7 7.469-7zM14 14h11v2H14zm-8.906 1.313l7.25 6.437L14 23.219V18h11v9H14v-.344l-.219-.281z"}})])
          )
        }
      }
    